<template>
  <v-card class="mx-auto" outlined>
    <div id="inspire">
      <v-data-table
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-arrow-left',
            nextIcon: 'mdi-arrow-right',
            itemsPerPageOptions: [5, 10, 15, 50, 100]
          }"
          :headers="headers"
          :hide-default-footer="resultData.length <= 0"
          :items="resultData"
          :items-per-page="10"
          class="elevation-1"
          sort-by="count"
      >

        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <p class="mb-0" color="white">
                {{ (checkBranches ? $t("OPEN_BRANCHES_FOR_APPLY") : $t("OPEN_FACULTIES_FOR_APPLY")) }}</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="90vh">
              <template v-slot:activator="{  }">
                <v-col class="pa-1" cols="auto">

                  <v-btn
                      :fab="!$vuetify.breakpoint.mdAndUp"
                      :small="!$vuetify.breakpoint.mdAndUp"
                      class="mx-2"
                      color="primary"
                      @click="showScopeTreeFn()">
                    <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('SCOPE') }}</span>
                    <v-icon :right="$vuetify.breakpoint.mdAndUp">mdi-navigation</v-icon>
                  </v-btn>
                </v-col>

              </template>
              <v-card outlined>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card-title class="justify-center">
                      <span class="headline white--text text-thin">{{
                          formTitle
                        }}</span>
                  </v-card-title>


                </v-form>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-if="checkBranches" v-slot:item.branchName="{ item }">
          {{ serverTranslate(item.branchName) }}
        </template>

        <template v-slot:item.facultyName="{ item }">
          {{ serverTranslate(item.facultyName) }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="!item.activeForApply" bottom>
            <template v-slot:activator="{ }">
              <v-btn icon v-on="item.activeForApply">
                <v-icon
                    v-if="!item.activeForApply"
                    meduim
                    @click="toggleActivationItem(item)"
                >toggle_off
                </v-icon
                >
              </v-btn>
            </template>
            <span>{{ $t("ACTIVATE") }}</span>
          </v-tooltip>

          <v-icon
              v-if="item.activeForApply"
              color="success"
              meduim
              @click="toggleActivationItem(item)"
          >toggle_on
          </v-icon
          >
        </template>

        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} - {{ props.pageStop }} {{ $t('PAGE_TEXT') }} {{ props.itemsLength }}
        </template>
        <template v-slot:no-data>
          <v-alert class="mt-2" color="light5" icon="warning">
            {{ $t("NO_DATA") }}
          </v-alert>
        </template>
      </v-data-table>
      <pr-confirmDialog ref="confirm"></pr-confirmDialog>
      <pr-scope v-if="showScopeTree == true" :key="componentKey" :scopeFullPath="false" v-on:setScope="onScopeChanged"/>

    </div>
  </v-card>
</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.ts";
import globalMethodsMixin from "@/mixins/globalMethods.ts";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import scope from "@/components/shared/ScopeTree.vue"

export default {
  name: "pr-certification-types",
  components: {
    "pr-confirmDialog": ConfirmDialog,
    "pr-scope": scope
  },
  mixins: [serverTranslationsMixin, globalMethodsMixin],
  data() {
    return {
      showScopeTree: false,
      componentKey: 0,
      dialog: false,
      valid: true,
      showAlert: false,
      checkBranches: false,
      errorMessages: "",
      resultData: [],
      branchesIds: [],
    };
  },
  computed: {
    direction: function () {
      return this.$store.state.direction;
    },

    headers: function () {
      if (!this.checkBranches) {
        return [
          {
            text: this.$t("ORDER"),
            align: "start",
            sortable: true,
            value: "count"
          },
          {
            text: this.$t("FACULTY"),
            align: "start",
            sortable: true,
            value: "facultyName"
          },
          {
            text: this.$t("ACTIONS"),
            value: "actions",
            sortable: false,
            width: "150px"
          }
        ];
      } else {
        return [
          {
            text: this.$t("ORDER"),
            align: "start",
            sortable: true,
            value: "count"
          },
          {
            text: this.$t("BRANCH"),
            align: "start",
            sortable: true,
            value: "branchName"
          },
          {
            text: this.$t("FACULTY"),
            align: "start",
            sortable: true,
            value: "facultyName"
          },
          {
            text: this.$t("ACTIONS"),
            value: "actions",
            sortable: false,
            width: "150px"
          }
        ];
      }

    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    onScopeChanged(changed) {
      if (changed) this.initialize();
    },
    showScopeTreeFn() {
      this.showScopeTree = true;
      this.showBranchesCount = false;
      this.componentKey += 1;
    },
    initialize() {
      this.$http.get("/api/general_data/get_faculty_branches/").then(
          res => {
            this.resultData = res.data.data.resultList.resultList;
            this.checkBranches = res.data.data.resultList.checkBranches;
          },
          err => {
            this.showToasted("error", err.response.data.message);
          }
      );
    },

    toggleActivationItem(item) {
      let newObj = {}
      if (this.checkBranches) {
         newObj = {
          branchId: item.id,
          activeForApply: !item.activeForApply,
          facultyId: item.facultyId,
          progHrId: item.progHrId
        }
      } else {
         newObj = {
          facultyId: item.id,
          activeForApply: !item.activeForApply,
          facultyHrId: item.facultyHrId
        }
      }
      this.$http.put(`/api/general_data/update_active_branches_or_faculties_for_apply/`, newObj).then(
          res => {
            this.initialize();
          },
          err => {
            this.showToasted("error", err.response.data.message)
            this.initialize();
          }
      );
    },

  }
};
</script>
